import { create } from 'zustand';
import { FormType } from '../../types';

const INITIAL_FORM_STATE: FormType = {
  title: '',
  address: '',
  postOffice: {
    id: '',
  },
  employees: 0,
  contacts: [],
};

type DetailPageState = {
  isLoading: boolean;
  form: FormType;
};

type DetailPageActions = {
  setIsLoading: (isLoading: boolean) => void;
  setForm: (form: FormType) => void;
  reset: () => void;
};

export const useDetailPageStore = create<DetailPageState & DetailPageActions>((set) => ({
  isLoading: true,
  form: { ...INITIAL_FORM_STATE },
  setIsLoading: (isLoading: boolean) => set({ isLoading }),
  setForm: (form: FormType) => set({ form }),
  reset: () => set({ form: { ...INITIAL_FORM_STATE }, isLoading: true }),
}));
